import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export const ORG_NOTIFICATION_SETTINGS_KEY = 'org-notification-settings'

export const SLACK_CHANNEL_NOT_FOUND = 'SLACK_CHANNEL_NOT_FOUND'

export type OrganizationNotificationSettings = {
  slackChannelName: string | null
  expiringSoonEnabled: boolean
  expiredEnabled: boolean
}

export type NotificationSettingsErrorResponse = {
  code?: string
  message?: string
}

type UpdateNotificationSettingsPayload = OrganizationNotificationSettings & {
  orgId: string
}

export function useGetNotificationSettings(orgId?: string, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [ORG_NOTIFICATION_SETTINGS_KEY, orgId],
    queryFn: async () => {
      const { data } = await apiClient.get<OrganizationNotificationSettings>(
        `/int/v3/organizations/${orgId}/notification-settings`
      )

      return data
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(orgId) && enabled,
  })
}

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ orgId, ...payload }: UpdateNotificationSettingsPayload) => {
      const { data } = await apiClient.put<OrganizationNotificationSettings>(
        `/int/v3/organizations/${orgId}/notification-settings`,
        payload
      )

      return data
    },
    onSuccess: (_, { orgId }) =>
      queryClient.invalidateQueries({ queryKey: [ORG_NOTIFICATION_SETTINGS_KEY, orgId] }),
  })
}
